import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ progress = 0, progressRef, numberRef, pointerRef }) => {
    let progressBar = {
        height: '100%',
        width: `${progress}%`,
        background: 'linear-gradient(90deg, var(--goldColor) 0%, var(--goldOp5) 100%)',
        transition: 'width 0.2s ease'
    };
    const progressText = {
        position: 'absolute',
        left: `${progress}%`,
        bottom: '30px',
        transform: 'translate(-50%, 0)',
        color: 'var(--goldColor)',
        transition: 'left 0.2s ease'
    };
    const progressPointer = {
        position: 'absolute',
        left: `${progress}%`,
        bottom: '0',
        width: '1px',
        height: '30px',
        background: 'var(--goldColor)',
        transition: 'left 0.2s ease'
    };
    const progressWraper = { position: 'relative' };
    const progressBarWraper = {
        height: '10px',
        background: 'var(--greyExtraDarkTransparentColor)',
        'border-radius': '6px',
        overflow: 'hidden'
    };

    return (
        <div style={progressWraper}>
            <p ref={numberRef} style={progressText}>{`${progress}%`}</p>
            <div ref={pointerRef} style={progressPointer}></div>
            <div style={progressBarWraper}>
                <div ref={progressRef} style={progressBar}></div>
            </div>
        </div>
    );
};

ProgressBar.propTypes = { progress: PropTypes.number };

export default ProgressBar;
